import {Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Melody} from "../../model/melody";
import {AudioService} from "../../services/audio.service";
import {Subscription} from "rxjs";
import {SubscriberService} from "../../services/subscriber.service";
import {ContentStatus} from "../../model/content-status";

declare var $: any;

@Component({
  selector: '[app-melody-item]',
  templateUrl: './melody-item.component.html',
  styleUrls: ['./melody-item.component.css']
})
export class MelodyItemComponent implements OnInit, OnDestroy {
  @Input() melody: Melody;

  @ViewChild("progressBar") private progressBar: ElementRef;

  purchased: boolean;
  progressBarInitialized: boolean;

  subscription: Subscription;

  constructor(private readonly audioService: AudioService,
              private readonly subscriberService: SubscriberService) {
    this.purchased = false;
    this.progressBarInitialized = false;
    this.subscription = new Subscription();
  }

  ngOnInit(): void {
    this.subscription.add(
      this.audioService.getState()
        .subscribe(state => {
          if (state.isPlaying && this.melody.isPlaying) {
            this.initProgressBar();
            if (state.currentTime && state.duration && this.progressBarInitialized) {
              $(this.progressBar.nativeElement).circleProgress('value', Number(state.currentTime) / Number(state.duration));
            }
          } else {
            this.destroyProgressBar();
          }
        })
    );

    this.subscription.add(
      this.subscriberService.favoriteMelodiesIds.subscribe(melodies => {
        this.melody.favorite = melodies.filter(melodyId => melodyId == this.melody.id).length > 0;
      })
    );

    this.subscription.add(
      this.subscriberService.subscriberMelodies.subscribe(() => this.checkSubscriberMelodies())
    );
  }

  play(): void {
    this.audioService.togglePlay(this.melody);
  }

  initProgressBar(): void {
    if (!this.progressBarInitialized) {
      $(this.progressBar.nativeElement).circleProgress({
        startAngle: -Math.PI / 2,
        value: 0,
        animation: true,
        size: 36,
        fill: {color: "#191c22"},
        emptyFill: "#ffffff",
        strokeLine: 20
      });
      this.progressBarInitialized = true;
    }
  }

  destroyProgressBar(): void {
    if (this.progressBarInitialized) {
      const progressBar = $(this.progressBar.nativeElement);
      const circleProgress = progressBar.data('circle-progress');
      $(circleProgress.canvas).remove();
      progressBar.removeData('circle-progress');

      this.progressBarInitialized = false;
    }
  }

  toggleFavorite(): void {
    this.subscriberService.toggleFavorite(this.melody);
  }

  purchaseMelody(): void {
    this.subscriberService.purchaseMelodyPopup(this.melody);
  }

  private checkSubscriberMelodies(): void {
    let status = this.subscriberService.getSubscriberMelodyStatus(this.melody.id)
    this.purchased = status == ContentStatus.ACTIVE || status == ContentStatus.ACTIVATING || status == ContentStatus.DEACTIVATING;
  }

  ngOnDestroy(): void {
    if (this.melody.isPlaying) {
      this.audioService.stopTrack();
    }
    if (this.progressBarInitialized) {
      this.destroyProgressBar();
    }
    this.subscription.unsubscribe();
  }
}
